export function getCompressorShow(state) {
  return state.compressorShow;
}
